import { AccordionV1State, withAuthorPanelSwitch, withStandardBaseCssClass } from '@adobe/aem-core-components-react-spa'
import { ComponentMapping, Container } from '@adobe/aem-react-editable-components'
import { Accordion, ACCORDION_VARIATION } from '@cox/core-ui8/dist/Accordion'

import CFAccordion from './CFAccordion'
import ManualAccordion from './ManualAccordion/index'
import { FragmentsAccordionCFType, ReactAccordionProps } from './types'
import { SM_CHEVRON_DOWN_RIVER_BLUE } from '../../assets/images'
import { getSpacing } from '../../utils/spacing-util'
import './ReactAccordion.scss'
import IsInEditorText from '../shared/IsInEditorText'

class ReactAccordion extends Container<ReactAccordionProps, AccordionV1State> {
  constructor(props: ReactAccordionProps) {
    super(props)
    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
      expandedItems: this.props.expandedItems
    }
  }

  get accordionContainerProps() {
    const attrs = this.containerProps
    attrs['className'] = attrs.className + ' ' + this.props.baseCssClass
    attrs['data-cmp-is'] = 'accordion'
    attrs['data-panelcontainer'] = 'accordion'
    attrs['data-testid'] = 'reactaccordion-container'
    return attrs
  }

  getAccordionContentDetails() {
    const {
      accordionIcon,
      fragmentContent,
      cqItemsOrder,
      cqItems,
      manualitems,
      fragmentitems = false,
      fragmentAccordions,
      offerCardAccordions = false,
      enableFAQs = false
    } = this.props
    const { elements, elementsOrder, model } = fragmentContent
    const isContentFragment = model
    const variation = offerCardAccordions ? ACCORDION_VARIATION.PSU : ACCORDION_VARIATION.BASE
    if (variation == ACCORDION_VARIATION.PSU) {
      const output: FragmentsAccordionCFType[] = []
      fragmentAccordions?.map((fragmentAccordion) => {
        const {
          accordionIcon = '',
          accordionIconAlttxt = '',
          title1 = '',
          title2 = '',
          bulletIcon = '',
          bulletPoints = []
        } = fragmentAccordion
        output.push({
          accordionIcon,
          accordionIconAlttxt,
          title1,
          title2,
          bulletIcon,
          bulletPoints
        })
      })
      return (
        <Accordion
          removePadding={this.props.removePadding}
          accordionIcon={SM_CHEVRON_DOWN_RIVER_BLUE}
          variation={variation}
          accordionItems={output}
          alwaysOpen={!this.props.singleExpansion}
          defaultActiveKey={this.state.expandedItems}
        />
      )
    } else if (fragmentitems || (isContentFragment && !manualitems)) {
      return (
        <CFAccordion
          removePadding={this.props.removePadding}
          elementsOrder={elementsOrder}
          elements={elements}
          expandedItems={this.state.expandedItems}
          accordionIcon={accordionIcon}
          singleExpansion={this.props.singleExpansion}
          variation={variation}
          enableFAQs={enableFAQs}
          fragmentitems={fragmentitems}
          fragmentAccordions={fragmentAccordions}
          isContentFragment={isContentFragment}
          manualitems={manualitems}
        />
      )
    } else {
      return (
        <ManualAccordion
          accordionIcon={accordionIcon}
          variation={variation}
          alwaysOpen={!this.props.singleExpansion}
          childComponents={this.childComponents}
          cqItems={cqItems}
          cqItemsOrder={cqItemsOrder}
          defaultActiveKey={this.state.expandedItems}
          enableFAQs={enableFAQs}
        />
      )
    }
  }

  get accordionContent() {
    return <>{this.getAccordionContentDetails()}</>
  }

  render() {
    const {
      isInEditor = false,
      id = '',
      top = false,
      right = false,
      bottom = false,
      left = false,
      lob = '',
      hideMCP = false
    } = this.props

    // Checks if hideMCP flag is true and that display is in dispatcher, not in author:
    const mcpClass = hideMCP && isInEditor == false ? 'd-none' : ''

    return (
      <>
        {IsInEditorText(isInEditor, 'React Accordian')}
        <div
          {...this.accordionContainerProps}
          id={id}
          className={`${getSpacing(top, right, bottom, left)} ${lob} ${mcpClass}`}
        >
          {this.accordionContent}
          {this.placeholderComponent}
        </div>
      </>
    )
  }
}

export default withStandardBaseCssClass(withAuthorPanelSwitch(ReactAccordion), 'cmp-accordion')
